var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiAssistantLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.115,
    height: 21.5,
    viewBox: "0 0 25.115 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28697",
    "data-name": "Group 28697",
    transform: "translate(10588 -1142.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51701",
    "data-name": "Path 51701",
    d: "M229.766,127.111h-.326a.322.322,0,0,1-.322-.322V122.3a.322.322,0,0,1,.322-.322h.326a.322.322,0,0,1,.322.322v4.486a.322.322,0,0,1-.322.322",
    transform: "translate(-10805.046 1021.762)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51702",
    "data-name": "Path 51702",
    d: "M227.952,115.32a1.147,1.147,0,1,1-1.147-1.147,1.147,1.147,0,0,1,1.147,1.147h0",
    transform: "translate(-10802.248 1028.077)",
    fill: "#e55660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51703",
    "data-name": "Path 51703",
    d: "M193.638,144.467V141.7a3.829,3.829,0,0,0-3.829-3.829H177.683a3.829,3.829,0,0,0-3.829,3.828h0v2.77a1.682,1.682,0,0,0-1.431,1.663v3.391a1.682,1.682,0,0,0,1.431,1.662v1.087a2.57,2.57,0,0,0,2.57,2.569h14.645a2.57,2.57,0,0,0,2.57-2.569h0v-1.087a1.682,1.682,0,0,0,1.432-1.663v-3.39a1.682,1.682,0,0,0-1.432-1.663",
    transform: "translate(-10759.189 1008.911)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51704",
    "data-name": "Path 51704",
    d: "M201.316,161.983H189.6a2.7,2.7,0,0,1-2.7-2.7V155.52a2.7,2.7,0,0,1,2.7-2.7h11.721a2.7,2.7,0,0,1,2.7,2.7v3.766a2.7,2.7,0,0,1-2.7,2.7",
    transform: "translate(-10770.899 996.813)",
    fill: "#333949"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1487",
    "data-name": "Ellipse 1487",
    cx: 2.417,
    cy: 2.417,
    rx: 2.417,
    ry: 2.417,
    transform: "translate(-10581.743 1151.755)",
    fill: "none",
    stroke: "#36a196",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1488",
    "data-name": "Ellipse 1488",
    cx: 2.417,
    cy: 2.417,
    rx: 2.417,
    ry: 2.417,
    transform: "translate(-10573.875 1151.755)",
    fill: "none",
    stroke: "#36a196",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51705",
    "data-name": "Path 51705",
    d: "M168.635,178.849h-.894a1.769,1.769,0,0,1-1.769-1.769v-3.242a1.769,1.769,0,0,1,1.769-1.769h.894Z",
    transform: "translate(-10753.972 981.249)",
    fill: "#333949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51706",
    "data-name": "Path 51706",
    d: "M283.42,178.849h.894a1.769,1.769,0,0,0,1.769-1.769v-3.242a1.769,1.769,0,0,0-1.769-1.769h-.894Z",
    transform: "translate(-10848.968 981.249)",
    fill: "#333949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51707",
    "data-name": "Path 51707",
    d: "M185.035,203.834H176.4a2.635,2.635,0,0,1-2.5-2.753V200.9",
    transform: "translate(-10760.389 957.931)",
    fill: "none",
    stroke: "#333949",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51708",
    "data-name": "Path 51708",
    d: "M227.952,211.016a1.147,1.147,0,1,1-1.147-1.147,1.147,1.147,0,0,1,1.147,1.147Z",
    transform: "translate(-10802.248 950.674)",
    fill: "#e55660"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantLogo);
export default __webpack_public_path__ + "static/media/ai-assistant-logo.43e50f6ae0be50d8e015f47ae3992dbf.svg";
export { ForwardRef as ReactComponent };